import React from "react";
import { Colours } from "@learningblocks/shared-components";
import ContentLoader from "react-content-loader";
import cname from "../style.module.scss";

export function SliderBlockLoader() {
  return (
    <ContentLoader
      className={cname.loader}
      speed={2}
      viewBox="0 0 100% 100%"
      backgroundColor={Colours.colorPrimary}
      foregroundColor="#3997dc"
    >
      <rect x="2" y="0" rx="3" ry="3" width="1000" height="100" />
    </ContentLoader>
  );
}

SliderBlockLoader.propTypes = {};

SliderBlockLoader.defaultProps = {};
